<style lang="scss">
  @import '../stylesheets/variables';

  .row {
    .button-group {
      margin-bottom: 0;

      @media #{$small-only} {
        text-align: center;
        margin-top: 10px;
      }

      .button {
        background: #EEEEEE;
        color: #B2B2B2;
        transition: 125ms background;
        min-width: 75px;

        &:last-child { margin-right: 0;}
        &:hover { background: darken(#EEEEEE, 10%); }
        &.active {
          background: #009EE2;
          color: #FFFFFF;
          .icon-fill { fill: #FFFFFF; }
        }

        .icon-fill { fill: #B2B2B2; }
        .icon {
          display: inline-block;
          vertical-align: middle;
        }
        .description {
          display: inline-block;
          vertical-align: middle;
          max-width: 95px;
          text-align: left;

          &.description-gap { margin-left: 5px; }
        }
      }
    }
  }
</style>

<template>
  <div :class="checkboxClass">
    <a class="button" :class="{ active: item.value == selected.value }" v-for="item in items" :key="item.value" @click="onChange(item.value)">
      <span class="icon" v-if="item.icon" v-html="item.icon"></span>
      <span class="description" :class="{ 'description-gap': item.icon && item.text }" v-if="item.text" v-html="item.text"></span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    items: { required: true },
    selected: { required: true },
    name: { required: true },
    size: { default: 'medium' },
    expanded: { type: Boolean },
  },
  computed: {
    checkboxClass() {
      return `${this.size} ${this.expanded ? 'expanded' : ''} button-group`;
    },
  },
  methods: {
    onChange(value) {
      this.$emit('change', { value });
    },
  },
};
</script>
